import type * as THREE from "three/webgpu";

export type InkingIncludeCategory = "primitive" | "mannequin" | "blend";

export const INKING_LAYER_BY_CATEGORY: Record<InkingIncludeCategory, number> = {
  primitive: 1,
  mannequin: 2,
  blend: 3,
};

export function markInkingCategory(
  obj: THREE.Object3D,
  category: InkingIncludeCategory,
): void {
  obj.userData.poserefInkingInclude = category;
  obj.layers.enable(INKING_LAYER_BY_CATEGORY[category]);
}
